module.exports = __webpack_public_path__ + "static/Screen Shot 2020-05-29 at 11.31.42 AM 2-31408b4f97522077ee197d99ec27e87d.png";